import { MenuItem, Tooltip } from "@material-ui/core";
import * as React from "react";
import { Field } from "redux-form";
import { FormSelectComponent } from "../components";
import { StyledFormControl, StyledInputLabel } from "../../../../styles/form";
import { styles } from "../../../../styles/general";
import { withStyles } from "@material-ui/core/styles";
import { InfoOutlined } from "@material-ui/icons";

class FormSelect extends React.Component<any, any> {
    public render() {
        const {
            // classes,
            data,
            disabled,
            label,
            name,
            onChange,
            required,
            validate,
            isHideNone,
        } = this.props;

        return (
            <StyledFormControl>
                <StyledInputLabel
                    htmlFor={name}
                >
                    {label} {required ? <span>*</span> : null}
                </StyledInputLabel>
                <Field
                    value=""
                    name={name}
                    component={FormSelectComponent}
                    onChange={onChange}
                    required={required}
                    disabled={disabled}
                    validate={validate}
                >
                    {isHideNone ? "" :
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                    }
                    {renderMenuItems(data || [], "id")}
                </Field>
            </StyledFormControl>
        );
    }
}

const renderMenuItems = (data: any, val: string) =>
    data.map((item: any, ind: any) => (
        <MenuItem key={ind} value={item[val]}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {item.code
                    ? item.code + "-" + item.name || item.type || item.description
                    : item.name || item.type || item.description}
                {item.info && <Tooltip title={item.info}><InfoOutlined color="action" style={{ marginLeft: 8, }} /></Tooltip>}
            </div>
        </MenuItem>
    ));

export default withStyles(styles)(FormSelect);
